import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=2b877611&scoped=true"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=2b877611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b877611",
  null
  
)

export default component.exports